import { ChangeDetectionStrategy, Component } from '@angular/core';
import { isOrthographicVideoOutput } from '../../../../../../../cross-team-shared/misc-utils/output-utils';
import { MeasureToolMode } from '../../../../../../../cross-team-shared/types/tool-modes';
import { freePointModeIcon } from '../../../../../../shared/icons/toolbars/free-point-mode-icon';
import { subpointModeIcon } from '../../../../../../shared/icons/toolbars/subpoint-mode-icon';
import { AbstractToolModeSecondaryToolbar } from '../abstract-tool-mode-secondary-toolbar';

@Component({
  selector: 'h3-measure-tool-3d-secondary-toolbar',
  templateUrl: './measure-tool-3d-secondary-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MeasureTool3dSecondaryToolbarComponent extends AbstractToolModeSecondaryToolbar {
  freePointModeValue: MeasureToolMode = 'free-point';
  freePointModeIcon = freePointModeIcon;
  subpointModeValue: MeasureToolMode = 'subpoint-height';
  subpointModeIcon = subpointModeIcon;
  hasOrthographicVideoOutput = this.taskWorkspaceStore
    .state()
    .project.outputs.some(isOrthographicVideoOutput);

  protected override toolName = 'Measure' as const;
}
